import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/icons-material/esm/ArrowForward.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/icons-material/esm/ArrowOutward.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/icons-material/esm/TrendingDown.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/icons-material/esm/TrendingFlat.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/icons-material/esm/TrendingUp.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/Button/Button.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/Card/Card.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/CardContent/CardContent.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/CardHeader/CardHeader.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/Chip/Chip.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/Container/Container.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/material/esm/Grid/Grid.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/List/List.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/ListItem/ListItem.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/ListItemButton/ListItemButton.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/ListItemIcon/ListItemIcon.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/ListItemText/ListItemText.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/Stack/Stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/styles/adaptV4Theme.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/styles/styled.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/styles/ThemeProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/material/esm/styles/ThemeProviderWithVars.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/styles/useTheme.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/styles/useThemeProps.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/Typography/Typography.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/styled-engine/esm/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/system/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/system/esm/Container/Container.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/system/esm/Container/createContainer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/system/esm/createBox/createBox.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/system/esm/cssVars/createCssVarsProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/system/esm/GlobalStyles/GlobalStyles.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/system/esm/Grid/createGrid.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/system/esm/Grid/Grid.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/system/esm/RtlProvider/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/system/esm/Stack/createStack.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/system/esm/Stack/Stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/system/esm/ThemeProvider/ThemeProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/system/esm/useTheme/useTheme.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/system/esm/useThemeProps/useThemeProps.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/system/esm/useThemeWithoutDefault/useThemeWithoutDefault.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/buttons/SLButtonGroupAnrufenBuchen.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SLButtonGroupChatBuchen"] */ "/vercel/path0/src/components/buttons/SLButtonGroupChatBuchen.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SLBlogPreviewCard"] */ "/vercel/path0/src/components/cards/SLBlogPreviewCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SLCard"] */ "/vercel/path0/src/components/cards/SLCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SLCardTeamMember"] */ "/vercel/path0/src/components/cards/SLCardTeamMember.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/i18n/SLLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SLSubpageChrome"] */ "/vercel/path0/src/components/layout/SLSubpageChrome.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SLSubpageHeaderMedia"] */ "/vercel/path0/src/components/layout/SLSubpageHeaderMedia.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SLSubpageHeaderTextBlock"] */ "/vercel/path0/src/components/layout/SLSubpageHeaderTextBlock.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/other/SLDeferredMount.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SLProgressiveCarousel"] */ "/vercel/path0/src/components/other/SLProgressiveCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SLExpertiseInsolvenzberichte"] */ "/vercel/path0/src/components/sections/expertise/SLExpertiseInsolvenzberichte.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StatisticsDetailAccordions"] */ "/vercel/path0/src/components/sections/expertise/statistics/StatisticsDetailAccordions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StatisticsSparklineCard"] */ "/vercel/path0/src/components/sections/expertise/statistics/StatisticsSparklineCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SLSectionCourtsSlider"] */ "/vercel/path0/src/components/sections/SLSectionCourtsSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SLSectionFaqs"] */ "/vercel/path0/src/components/sections/SLSectionFaqs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SLSectionNotariesSlider"] */ "/vercel/path0/src/components/sections/SLSectionNotariesSlider.tsx");
